import * as React from 'react'
import cx from 'classnames'
import { observer } from 'mobx-react'
import styles from './Welcome.sass'
import Button from 'components/Button'
import ConversationViewModel from '../../ConversationViewModel'
import Spinner from 'components/Spinner'
import LoadError from '../LoadError'
import { useBrandingSettings } from 'hooks/branding'

interface WelcomeProps extends React.HTMLAttributes<HTMLDivElement> {
  vm: ConversationViewModel
  small?: boolean
  welcomeActions?: WelcomeAction[]
}

export interface WelcomeAction {
  onClick: () => unknown
  children: React.ReactNode
}

export default observer(function Welcome({
  vm,
  small,
  welcomeActions = [],
}: WelcomeProps) {
  const allMessagesLoaded = vm.scroller.isDone
  const { corporateMode } = useBrandingSettings()
  return (
    <div className={cx(styles.root, small && styles.small)}>
      <div className={cx(styles.box, !allMessagesLoaded && styles.hidden)}>
        <div className={styles.content}>
          <h4 className={styles.title}>Welcome to the chat</h4>
          <p className={styles.description}>
            This is the very beginning of this conversation.
          </p>
          <div className={cx(styles.actions)}>
            {welcomeActions.map((action, i) => (
              <div className={styles.action} key={i}>
                <Button
                  block={small}
                  size="small"
                  type="translucent"
                  onClick={() => action.onClick()}
                >
                  {action.children}
                </Button>
              </div>
            ))}
          </div>
        </div>
        {!corporateMode && (
          <div className={styles.illustration}>
            <img
              src={require('assets/images/img_chat.svg')}
              alt="Phone with chat bubble"
            />
          </div>
        )}
      </div>
      {!vm.scroller.fetch.pending && vm.scroller.fetch.rejected && (
        <LoadError
          onRetryClick={() => vm.scroller.fetch()}
          error={vm.scroller.fetch.error}
        />
      )}
      {!allMessagesLoaded && !vm.scroller.fetch.rejected && (
        <div className={styles.loading}>
          <Spinner />
          <p className={styles.loadingMsg}>
            Loading more messages, hang tight.
          </p>
        </div>
      )}
    </div>
  )
})
